import { render } from "./ServicesPage.vue?vue&type=template&id=52c83db8&ts=true"
import script from "./ServicesPage.ts?vue&type=script&lang=ts&external"
export * from "./ServicesPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__